import React from 'react';
import { KBBlock } from '../../../types';
import { renderParagraph } from '../utils/renderInline';

interface Props {
  block: KBBlock;
  isEditing: boolean;
  onChange: (updates: Partial<KBBlock>) => void;
  onFinish: () => void;
}

const ParagraphBlock: React.FC<Props> = ({ block, isEditing, onChange, onFinish }) => {
  if (isEditing) {
    return (
      <textarea
        autoFocus
        value={block.content}
        placeholder="Type something… supports **bold**, *italic*, ~~strike~~, `code`, [link](url)"
        onChange={(e) => onChange({ content: e.target.value })}
        onBlur={onFinish}
        onKeyDown={(e) => { if (e.key === 'Escape') onFinish(); }}
        rows={Math.max(3, (block.content.match(/\n/g) || []).length + 2)}
        className="w-full bg-transparent border-none outline-none text-gray-700 text-base leading-relaxed resize-none placeholder-gray-300"
      />
    );
  }

  return (
    <p className={`text-base leading-relaxed text-gray-700 whitespace-pre-wrap ${!block.content ? 'text-gray-300 italic' : ''}`}>
      {block.content ? renderParagraph(block.content) : 'Empty paragraph — click to edit'}
    </p>
  );
};

export default ParagraphBlock;
